import AddIcon from '@material-ui/icons/Add';
import { RMSButton } from 'features/shared/components/buttons';
import usePermissions from 'features/shared/hooks/usePermissions';
import { PERMISSION_RESOURCES } from 'features/shared/constants/permissionResources';
import VehicleTowingDialog from './VehicleTowingDialog';
import { getDataGridToolbarProps } from 'features/shared/utility/dataGridToolbarHelper';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@material-ui/core';
import { CommonDataGrid } from 'features/shared/components/table';
import { executeApiAction } from '../../../shared/utility/apiHelper';
import { getVehicleTowingRecords } from '../../services/vehicleService';
import { TOWING_GRID_COLUMNS } from '../../constants/vehicleTowingTabConstants';
import FormSpinner from 'components/FormSpinner';

const VehicleTowingTab = ({ ptsVehicleID, canEdit: canEditVehicle = true }) => {
  const dispatch = useDispatch();
  const vehiclePermissions = usePermissions(PERMISSION_RESOURCES.VEHICLE);
  const canEdit = canEditVehicle && vehiclePermissions.Edit;
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);
  const [towingRecords, setTowingRecords] = useState([]);

  const loadTowingRecords = useCallback(async () => {
    if (!ptsVehicleID) return;

    await executeApiAction({
      setLoading,
      dispatch,
      action: () => getVehicleTowingRecords(ptsVehicleID),
      onSuccess: (data) => setTowingRecords(data),
    });
  }, [dispatch, ptsVehicleID]);

  useEffect(() => {
    loadTowingRecords();
  }, [loadTowingRecords]);

  return (
    <Box className="vehicle-grid-tab">
      {loading && <FormSpinner />}
      <Box className="person-addresses-tab__toolbar">
        <RMSButton
          label="Add Towing"
          prefixIcon={<AddIcon />}
          disabled={!canEdit || loading}
          onClick={() => {
            setEditing(null);
            setFormOpen(true);
          }}
        />
      </Box>
      <CommonDataGrid
        rows={towingRecords}
        columns={TOWING_GRID_COLUMNS}
        getRowId={(row) => row.ptsTowingID}
        toolbar={getDataGridToolbarProps({ printTitle: 'Vehicle Towing' })}
        actions={{
          edit: {
            visible: true,
            disabled: !canEdit || loading,
            onClick: (row) => {
              setEditing(row);
              setFormOpen(true);
            },
          },
        }}
      />

      {formOpen && (
        <VehicleTowingDialog
          ptsVehicleID={ptsVehicleID}
          towing={editing}
          canSave={canEdit}
          onClose={() => setFormOpen(false)}
          onSaved={() => {
            setFormOpen(false);
            loadTowingRecords();
          }}
        />
      )}
    </Box>
  );
};

export default VehicleTowingTab;
